module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAEAQMAAAAeUktpAAAAA1BMVEUAAACnej3aAAAADElEQVQI12NgIB4AAAAsAAGEoFnJAAAAAElFTkSuQmCC"